import { render, staticRenderFns } from "./ProposalCardHorizontal.vue?vue&type=template&id=e18f5c40"
import script from "./ProposalCardHorizontal.vue?vue&type=script&lang=js"
export * from "./ProposalCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ProposalCardHorizontal.vue?vue&type=style&index=0&id=e18f5c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports